import {LocalDate} from '@js-joda/core';
import {DatepickerDateFilter} from './datepicker.models';

/** Общая проверка доступности для сетки, предварительного выбора и итогового события. */
export class DatepickerDateRules {
  /** Период доступен, если хотя бы один день проходит все ограничения. */
  public static hasSelectableDay(
    start: LocalDate,
    end: LocalDate,
    minDate: LocalDate | null,
    maxDate: LocalDate | null,
    dateFilter: DatepickerDateFilter | null,
  ): boolean {
    const from = minDate && minDate.isAfter(start) ? minDate : start;
    const to = maxDate && maxDate.isBefore(end) ? maxDate : end;
    if (from.isAfter(to)) {
      return false;
    }
    if (!dateFilter) {
      return true;
    }
    // После отсечения границ ищем первый разрешённый день, не проверяя весь период без необходимости.
    for (let day = from; !day.isAfter(to); day = day.plusDays(1)) {
      if (dateFilter(day)) {
        return true;
      }
    }
    return false;
  }

  public static isSelectable(
    date: LocalDate,
    minDate: LocalDate | null,
    maxDate: LocalDate | null,
    dateFilter: DatepickerDateFilter | null,
  ): boolean {
    return (!minDate || !date.isBefore(minDate))
      && (!maxDate || !date.isAfter(maxDate))
      && (!dateFilter || dateFilter(date));
  }
}
